
import React, { useState, useEffect } from "react";
import './dashboard.css';
import Fab from '@mui/material/Fab';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FormHelperText } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Input from '@mui/material/Input';
import MenuItem from '@mui/material/MenuItem';
import { toast } from 'react-toastify';
import axios from '../../utils/axiosConfig';
import config from '../../utils/Config';
import dashboardService from '../../features/dashboard/dashboardService';
import commonService from '../../features/common/commonService';
import authService from '../../features/auth/authService';
import Spinner from '../Layout/Spinner';
import { IosShareOutlined } from "@mui/icons-material";
import { Link } from "react-router-dom";
import pdfService from '../../features/pdf/pdfService';
import InputLabel from '@mui/material/InputLabel';
import Tooltip from '@mui/material/Tooltip';
import {
  TablePagination,
  TableSortLabel
} from '@mui/material';
import * as ld from 'lodash';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';


function Dashboard(props) {

  const [schoolName, setVariantName] = React.useState([]);
  // const [open, setOpenAdd] = React.useState(false);
  let [dashboardData, setDashboardData] = useState({});
  let [dashboardUsersData, setDashboardUsersData] = useState([]);
  let [alldashboardUsersData, setAllDashboardUsersData] = useState([]);
  let [isButtonDisabled, setIsButtonDisabled] = useState('true');

  const [openAdd, setOpenAdd] = React.useState(false);
  const [openUpdate, setOpenUpdate] = React.useState(false);
  const [updateRow, setUpdateRow] = React.useState({});
  const [deleteRow, setDeleteRow] = React.useState({});

  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [schoolError, setSchoolError] = useState("");
  const [isUserInteracted, setIsUserInteracted] = useState(false);
  const [isUserInteractedwithFirstName, setIsUserInteractedwithFirstName] = useState(false);
  const [isUserInteractedwithLastName, setIsUserInteractedwithLastName] = useState(false);
  const [isUserInteractedwithSchool, setIsUserInteractedwithSchool] = useState(false);


  let [isLoading, setIsLoading] = useState(false);


  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50); // Set the number of rows per page here

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // useEffect(() => {
  // }, () => { });

  const addDashboardDialog = () => {
    setOpenAdd(true);
  };

  const updateDashboardDialog = (row) => {
    const school = dashboardData.schoolList.find((item) => item.schoolId === row.schoolId);
    console.log(school);
    console.log(row);
    row['schoolName'] = school.schoolName;
    console.log(row.accesslevel);
    if(row.accesslevel == 'all'){
      row['schoolName'] = 'All Schools';
    }
    console.log(row);
    setOldEmail(row.email);
    setUpdateRow(row);
    setOpenUpdate(true);
  }

  const addDashboardClose = () => {
    setOpenAdd(false);
  };

  const updateDashboardClose = () => {
    setOpenUpdate(false);
  };

  const handleFocus = (field) => {
    if (field == 'email') {
      setIsUserInteracted(true);
    } else if (field == 'firstname') {
      setIsUserInteractedwithFirstName(true);
    } else if (field == 'lastname') {
      setIsUserInteractedwithLastName(true);
    } else if (field == 'school') {
      setIsUserInteractedwithSchool(true);
    }
  };

  const [openDelete, setOpenDelete] = React.useState(false);
  const [dashboardUserName, setDashboardUserName] = React.useState('');

  const deleteDashboardDialog = (row) => {
    console.log(row);
    setDashboardUserName(row.firstname + ' ' + row.lastname);
    setOpenDelete(true);
    row.schoolId = row.schoolId;
    row.districtId = authService.getDist();
    setDeleteRow(row);
  };

  const deleteDashboardClose = () => {
    setOpenDelete(false);
    setDashboardUserName('');
  };

  const [isUserError, setIsUserError] = useState({
    firstNameError: false,
    lastNameError: false,
    emailError: false,
    schoolError: false,
  });

  const [isUpdateUserError, setIsUpdateUserError] = useState({
    firstNameUpdateError: false,
    lastNameUpdateError: false,
    emailUpdateError: false,
    schoolUpdateError: false,
  });

  const validateFormwithInteraction = () => {
    let isValid = false;
    let disableSave = 'true';
    // Regular expression to validate the email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Check if the email is empty or doesn't match the regular expression
    if (isUserInteracted && (email.trim() === '' || !emailRegex.test(email))) {
      setIsUserError({ ...isUserError, emailError: true });
    } else {
      isValid = true;
      disableSave = 'false';
      setIsUserError({ ...isUserError, emailError: false });
    }

    // Validate First Name
    if (isUserInteractedwithFirstName && firstName.trim() === '') {
      setIsUserError((prevState) => ({
        ...prevState,
        firstNameError: true
      }));
      isValid = false;
    } else {
      isValid = true;
      disableSave = 'false';
      setIsUserError((prevState) => ({
        ...prevState,
        firstNameError: false
      }));
    }

    // Validate Last Name
    if (isUserInteractedwithLastName && lastName.trim() === '') {
      setIsUserError((prevState) => ({
        ...prevState,
        lastNameError: true
      }));
      isValid = false;
    } else {
      isValid = true;
      disableSave = 'false';
      setIsUserError((prevState) => ({
        ...prevState,
        lastNameError: false
      }));
    }

    // Validate Last Name
    if (isUserInteracted && email.trim() === '') {
      setIsUserError((prevState) => ({
        ...prevState,
        emailError: true
      }));
      isValid = false;
    } else {
      isValid = true;
      disableSave = 'false';
      setIsUserError((prevState) => ({
        ...prevState,
        emailError: false
      }));
    }

    // Validate Last Name
    if (isUserInteractedwithSchool && selectedSchools.length == 0) {
      setIsUserError((prevState) => ({
        ...prevState,
        schoolError: true
      }));
      isValid = false;
    } else {
      isValid = true;
      disableSave = 'false';
      setIsUserError((prevState) => ({
        ...prevState,
        schoolError: false
      }));
    }
    return isValid;
  };

  const handleDelete = () => {
    console.log(deleteRow);
    setIsLoading(true);
    dashboardService.deletedashboarduser(deleteRow)
      .then((response) => {
        setIsLoading(false);
        console.log(response.data);
        if (response.data.success) {
          toast.success(response.data.message ? response.data.message : "Error in submiting the data");
          setOpenDelete(false);
          fetchData();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        toast.success(error.data.message ? error.data.message : "Error in submiting the data");
        setOpenDelete(false);
      });
  }

  const ITEM_HEIGHT = 34;
  const ITEM_PADDING_TOP = 4;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };




  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [oldEmail, setOldEmail] = useState('');
  const [selectedSchools, setSelectedSchools] = useState([]);

  const handleSave = async () => {
    if (validateForm()) {
      let accessLevel = 'school';
      if (isAllSelected()) {
        accessLevel = 'All';
      }
      const formData = {
        firstname: firstName,
        lastname: lastName,
        email: email,
        accesslevel: accessLevel,
        schoolList: selectedSchools,
        districtId: localStorage.getItem('districtId'),
      };

      try {
        setIsLoading(true);
        //const response = await axios.post('/dashboard/adddashboarduser', formData);
        dashboardService.addDashboardUser(formData)
          .then((response) => {
            console.log(response.data);
            setIsLoading(false);
            if (response.data.success) {
              toast.success(response.data.message ? response.data.message : "Error in submiting the data");
              setOpenAdd(false);
              fetchData();
             
              setTimeout(() => {
                window.location.reload();
            }, 7000);
            }
          })
          .catch((error) => {
            setIsLoading(false);
            console.error(error);
            toast.warning(error.response.data.message ? error.response.data.message : "Error in submiting the data");
            setOpenAdd(false);
          });
      } catch (error) {
        setIsLoading(false);
        console.error('Error fetching data:', error);
        toast.error(error.data.message ? error.data.message : "Error in submiting the data");
        setOpenAdd(false);
      }
    }
  };

  const handleUpdate = (row) => {
    console.log(row);
    console.log(oldEmail);
    try {
      setIsLoading(true);
      //const response = await axios.post('/dashboard/adddashboarduser', formData);
      dashboardService.editDashboardUser(row, authService.getDist(), oldEmail)
        .then((response) => {
          setIsLoading(false);
          console.log(response.data);
          if (response.data.success) {
            toast.success(response.data.message ? response.data.message : "Error in submiting the data");
            setOpenUpdate(false);
            fetchData();
          } else {
            toast.warning(response.data.message ? response.data.message : "Error in submiting the data");
            setOpenUpdate(false);
            fetchData();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.success(err.data.message ? err.data.message : "Error in submiting the data");
          setOpenUpdate(false);
          console.error(err);
        });
    } catch (error) {
      setIsLoading(false);
      console.error('Error fetching data:', error);
    }
  }

  const handleFirstNameChange = (event) => {
    setFirstName(event.target.value);
  };

  const handleLastNameChange = (event) => {
    setLastName(event.target.value);
  };

  const handleEmailChange = (event) => {

    const { value } = event.target;

    // Regular expression for email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Allow clearing the input field
    setEmail(value);
    // Validate email only if there is a value
    if (value === '') {
      setEmailError('');
    } else if (!emailPattern.test(value)) {
      setEmailError('Please enter a valid email address.');
    } else {
      setEmailError('');
    }
  };

  const handleSchoolsChange = (event) => {
    let allSelected = isAllSelected();
    // if(typeof(event.target.value) != 'String'){
    //   event.target.value = event.target.value.toString();
    // }
    if (!event.target.value.includes('select_all')) {
      if (!selectedSchools.includes(event.target.value)) {
        setSelectedSchools(event.target.value);
      } else {
        setSelectedSchools(selectedSchools.filter((school) => school !== event.target.value));
      }
    }

    if (event.target.value.includes('select_all')) {
      if (isAllSelected()) {
        setSelectedSchools([]);
      } else {
        const allSchoolIds = dashboardData.schoolList.map((variant) => variant.schoolId);
        setSelectedSchools(allSchoolIds)
      }
    }


  };



  const selectSchools = (event) => {
    const {
      target: { value },
    } = event;

    let duplicateRemoved = [];

    value.forEach((item) => {
      if (duplicateRemoved.findIndex((o) => o.id === item.id) >= 0) {
        duplicateRemoved = duplicateRemoved.filter((x) => x.id === item.id);
      } else {
        duplicateRemoved.push(item);
      }
    });

    setVariantName(duplicateRemoved);
  };

  useEffect(() => {
    document.title = props.title
    fetchData();
  }, []);

  function formatDate(inputDateStr) {
    // Step 1: Convert the input string to a Date object
    const inputDate = new Date(inputDateStr);

    // Step 2: Extract day, month, and year from the Date object
    const day = inputDate.getDate();
    const month = inputDate.getMonth() + 1; // January is month 0
    const year = inputDate.getFullYear();

    // Step 3: Format the day, month, and year to "mm-dd-yyyy" format
    const formattedDate = `${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}-${year}`;

    return formattedDate;
  }

  function formatDateexp(inputDateStr) {
    // Step 1: Convert the input string to a Date object
    const inputDate = new Date(inputDateStr);

    // Step 2: Extract day, month, and year from the Date object
    const day = inputDate.getDate();
    const month = inputDate.getMonth() + 1; // January is month 0
    const year = inputDate.getFullYear();

    // Step 3: Format the day, month, and year to "mm-dd-yyyy" format
    const formattedDate = `07-31-${year}`;

    return formattedDate;
  }

  const isAllSelected = () => {
    return selectedSchools.length === dashboardData.schoolList.length;
  };

  const handleSelectAll = (e) => {
    console.log(e.target.checked);
  };
  const [distNameDash, setDistNameDash] = useState('')

  const fetchData = async () => {
    setIsLoading(true);
    dashboardService.getDashboardPageDate({ districtId: authService.getDist() }).then((response) => {
      setDashboardData(response.data)
      if(response.data.orderReportSubmit === true){
        toast.info('Click the blue “Add Dashboard User” icon to enter Dashboard users.');
      }
      let setData = response.data.dashboardData
      setData = setData.map(element => {
        element['name'] = `${element['firstname']} ${element['lastname']}`
      })
      setDistNameDash(response.data.distName)
      console.log(response.data.dashboardData);
      // setDashboardUsersData(response.data.dashboardData);

      const uniqueEmailsWithAllAccess = {};
      let filteredData = response.data.dashboardData.filter((record) => {
        const { email, accesslevel } = record;
        if (accesslevel === 'All') {
          if (uniqueEmailsWithAllAccess[email]) {
            return false;
          } else {
            uniqueEmailsWithAllAccess[email] = true;
            return true;
          }
        }
        return true;
      });


      setDashboardUsersData(filteredData.sort((a, b) => {
        return a.firstname.localeCompare(b.firstname);
      }));

      if (response.data.dashboardData.length > 0) {
        setShowDbDownloadPdf(true)
      } else {
        setShowDbDownloadPdf(false)

      }
      // console.log(response.data);
      setAllDashboardUsersData(response.data.dashboardData);
      //toast.success(response.data.message ? response.data.message : "Error in submiting the data");
      setIsLoading(false);
    }).catch(err => {
      console.log(err);
      toast.error(err.response.data.message);
      setIsLoading(false);
    })
  };

  const [searchText, setSearchText] = useState('');
  const [showDbDownloadPdf, setShowDbDownloadPdf] = useState(false)

  const handleInputChange = (event) => {
    setSearchText(event.target.value);
    filterData(event.target.value);
  };
  const handleYearSelection = () => {
    toast.error("Restricted in historical data view");
  };

  const filterData = (searchText) => {
    const filtered = alldashboardUsersData.filter((record) => {
      for (const key in record) {
        if (key == 'firstname' || key == 'lastname' || key == 'email') {
          if (
            record[key].toString().toLowerCase().includes(searchText.toLowerCase())
          ) {
            return true;
          }
        }
      }
      return false;
    });
    setDashboardUsersData(filtered);
  };

  const downloadManageDbPdf = async () => {
    let hdrImage = "data:image/png;base64,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"
    // let hdrImage = './assets/images/header11.png';
    let doc = new jsPDF('p');
    doc.addImage(hdrImage, 'PNG', 14, 14, 30, 8, 'logo');
    doc.setFontSize(14);
    doc.setTextColor(143, 149, 151);
    doc.text(14, 28, 'CalSCHLS Coordinator Portal');

    doc.setFontSize(12);
    doc.setTextColor(143, 149, 151);
    doc.text(14, 37, '');
    doc.text(14, 40, 'DASHBOARD USERS');
    doc.text(14, 33, '');
    doc.setFontSize(12);
    doc.setTextColor(248, 119, 28);
    doc.text(14, 49, distNameDash);
    console.log('dashboardData', dashboardData);
    console.log(localStorage.getItem('districtId'));


    /* 'DASHBOARD USER' Table */
    doc.autoTable({
      startY: 53,
      tableLineColor: [231, 76, 60],
      styles: {
        lineColor: 240,
        lineWidth: 0.1,
      },
      headStyles: {
        fillColor: [0, 60, 104],
        textColor: 240,
        fontSize: 8,
        fontStyle: 'bold',
        halign: 'center'
      },
      bodyStyles: {
        textColor: [0, 60, 104],
        fontSize: 9
      },
      body: dashboardUsersData,
      columns: getColumns(),

      didParseCell: function (data) {
        if ((data.row.section === 'body') && (data.column.dataKey === 'accesslevel')) {
          data.cell.text[0] = data.cell.raw.charAt(0).toUpperCase() + data.cell.raw.slice(1);
        }
      }
    });

        // Save PDF with District Name
        try {
          const fileName = await pdfFileNameWithDist(localStorage.getItem('districtId'));
          if (fileName) {
              doc.save(fileName); 
          } else {
              console.error("File name generation failed.");
          }
        } catch (error) {
            console.error("Error generating or saving PDF: ", error);
        }  
    // doc.save(pdfFileNameWithDist(localStorage.getItem('districtId')));
  }

  const getColumns = () => {
    let output = [];
    output.push({ header: 'NAME', dataKey: 'name' });
    output.push({ header: 'EMAIL', dataKey: 'email' });
    output.push({ header: 'SCHOOL', dataKey: 'school' });
    output.push({ header: 'ACCESS LEVEL', dataKey: 'accesslevel' });
    output.push({ header: 'SUBMITTED DATE', dataKey: 'submitteddDate' });
    output.push({ header: 'EXP. DATE', dataKey: 'expDate' });
    return output;
  }

  const getAcademicYearFormatted = async () => {
    let academicYearId = localStorage.getItem("academicyear");
    let formattedYear;

    try {
        const response = await commonService.getAcademicYearById(academicYearId);
        if (response && response.academicYear) {
            const academicYear = response.academicYear.year;
            const startYear = academicYear.split('-')[0].slice(-2); // Get last two digits of the first year
            const endYear = academicYear.split('-')[1].slice(-2);
            formattedYear = startYear + endYear;
        } else {
            console.error("Academic year not found in the response.");
        }
    } catch (error) {
        console.error("Error fetching academic year:", error);
    }

    return formattedYear;
  };

  const pdfFileNameWithDist = async (distName) => {
    let today = new Date();
    let formattedYear = await getAcademicYearFormatted();
    
    if (!formattedYear) {
      console.error("Formatted year not available.");
      return ""; 
    }
    console.log("formattedYear - report:", formattedYear);
  
    try {
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      let hoursMint = `${String(today.getHours()).padStart(2, '0')}${String(today.getMinutes()).padStart(2, '0')}`;


      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      today = `DashboardUsers_${formattedYear}_${dashboardData.distName.replace(/\s+|\\|\//g, "")}_${yyyy}${mm}${dd}${hoursMint}.pdf`;
    } catch (error) {
      console.log(`ERROR: ${error}, in pdfFileNameWithDist().`);
    }
    return today;
  }


  const validateForm = () => {
    let isValid = true;

    // Validate First Name
    if (firstName.trim() === '') {
      setIsUserError((prevState) => ({
        ...prevState,
        firstNameError: true
      }));
      isValid = false;
    } else {
      setIsUserError((prevState) => ({
        ...prevState,
        firstNameError: false
      }));
    }

    // Validate Last Name
    if (lastName.trim() === '') {
      setIsUserError((prevState) => ({
        ...prevState,
        lastNameError: true
      }));
      isValid = false;
    } else {
      setIsUserError((prevState) => ({
        ...prevState,
        lastNameError: false
      }));
    }

    // Validate Last Name
    if (email.trim() === '') {
      setIsUserError((prevState) => ({
        ...prevState,
        emailError: true
      }));
      isValid = false;
    } else {
      setIsUserError((prevState) => ({
        ...prevState,
        emailError: false
      }));
    }

    // Validate Last Name
    if (selectedSchools.length == 0) {
      setIsUserError((prevState) => ({
        ...prevState,
        schoolError: true
      }));
      isValid = false;
    } else {
      setIsUserError((prevState) => ({
        ...prevState,
        schoolError: false
      }));
    }
    if (isValid) {
      setIsButtonDisabled('false');
    }
    return isValid;
  };


  return (
    <div style={{ 'overflow-x': 'hidden' }}>
      {isLoading === true ? <Spinner /> : null}
      {localStorage.getItem("academicyear") === 'currentyear' && (
        <div className="marquee-container">
          <div className="marquee-content">
            <p>New Dashboard users added to the portal may experience a delay before gaining initial access to the Private District Dashboards.</p>
          </div>
        </div>
      )}
      {/* {(dashboardData.orderReportSubmit == true  || dashboardData.subscriptionEndDate != null || dashboardData.surveyRegSubmitAction != null)? */}
       {(dashboardData.orderReportSubmit  == true)?
      
        <>
          <div className='pageHeader'>
            <div style={{ display: 'inline-block', width: '91%' }} className="pageText">Manage Dashboard Users</div>
            {showDbDownloadPdf ?
              <div style={{ display: 'inline-block' }}>

                <Button onClick={downloadManageDbPdf} >
                  <img className='pdfImage' src={require('../../assets/images/downloadpdf_new.png')} alt='Download Pdf'></img>
                </Button>

              </div> : ''}
          </div>
          <div className='pageContent'>
            <div className='dash_UserDetails'>
              <div className='dash_countyDetails'>
                <span className='dash_labelText'>County :</span>
                <span className='dash_valueText'>{dashboardData.countyName}</span>
              </div>
              <div className='dash_districtDetails'>
                <span className='dash_labelText'>District :</span>
                <span className='dash_valueText'> {dashboardData.distName}</span>
              </div>
              {localStorage.getItem('academicyear') === 'currentyear' && (
                <>
                <Tooltip title='Add Dashboard user' placement="top-start">
                <div className='dash_addDashUser'>
                  <span><Fab size="small" color="primary" aria-label="add" className='dash_addButton' onClick={addDashboardDialog}><DashboardCustomizeIcon /></Fab></span>
                  <span className='dash_valueText'>Add Dashboard Users</span>
                </div>
              </Tooltip>
              <Dialog
                open={openAdd}
                onClose={addDashboardClose}
                aria-labelledby="addDashboardLabel"
                aria-describedby="addDashboardDescription"
                sx={{
                  "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                      width: "100%",
                      maxWidth: "400px",  // Set your width here
                    },
                  },
                }}
              >
                <DialogTitle id="addDashboardTitle" className="dash_dailogTitle">
                  ADD DASHBOARD USER
                </DialogTitle>
                <DialogContent sx={{ widdth: '100%' }}>
                <DialogContentText id="addDashboardDescription">
                  <FormControl sx={{ width: 350 }} error={isUserError.firstNameError}>
                    <TextField
                      error={isUserError.firstNameError}
                      autoFocus
                      margin="dense"
                      id="fname"
                      label="First name"
                      type="text"
                      fullWidth
                      variant="standard"
                      value={firstName}
                      onChange={handleFirstNameChange}
                      onBlur={validateFormwithInteraction}
                      onFocus={(e) => { handleFocus('firstname') }}
                      inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input text
                      InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input label fullWidth
                      sx={{
                        marginTop: '0px', backgroundColor: 'rgba(0,0,0,.04)', borderRadius: "5px 5px 0px 0px",
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "#000000",
                        }
                      }}
                    />
                    {isUserError.firstNameError && <FormHelperText sx={{ marginLeft: '0px' }}>Enter first name</FormHelperText>}
                  </FormControl>
                  <FormControl sx={{ width: 350, paddingTop: '20px' }} error={isUserError.lastNameError}>
                    <TextField
                      error={isUserError.lastNameError}
                      autoFocus
                      margin="dense"
                      id="lname"
                      label="Last name"
                      type="text"
                      fullWidth
                      variant="standard"
                      value={lastName}
                      onChange={(e) => {
                        handleLastNameChange(e)
                      }}
                      onBlur={validateFormwithInteraction}
                      onFocus={(e) => { handleFocus('lastname') }}
                      inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input text
                        InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input label              fullWidth
                      sx={{
                        marginTop: '0px', backgroundColor: 'rgba(0,0,0,.04)', borderRadius: "5px 5px 0px 0px",
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "#000000",
                        }
                      }}
                    />
                    {isUserError.lastNameError && <FormHelperText sx={{ marginLeft: '0px' }}>Enter last name</FormHelperText>}
                  </FormControl>
                  <FormControl sx={{ width: 350, paddingTop: '20px' }} error={isUserError.emailError}>
                    <TextField
                      error={isUserError.emailError}
                      autoFocus
                      margin="dense"
                      id="email"
                      label="Email"
                      type="email"
                      fullWidth
                      variant="standard"
                      value={email}
                      onChange={(e) => {
                        handleEmailChange(e)
                      }}
                      onBlur={validateFormwithInteraction}
                      onFocus={(e) => { handleFocus('email') }}
                      inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input text
                        InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input label              fullWidth
                      sx={{
                        marginTop: '0px', backgroundColor: 'rgba(0,0,0,.04)', borderRadius: "5px 5px 0px 0px",
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "#000000",
                        }
                      }}
                    />
                   {emailError && <div className='error' style={{color: '#d32f2f'}}>{emailError}</div>}
                   {isUserError.emailError && !emailError &&<FormHelperText sx={{ marginLeft: '0px' }}>Enter email</FormHelperText>}
                  </FormControl>


                  <FormControl variant="filled" sx={{ width: 350, marginTop: '25px' }} error={isUserError.schoolError}>
                    <InputLabel id="selectAllDist-label" sx={{ fontSize: 13, width: '100%', padding: '0', color: '#000000', marginLeft: '0px' }}>School(s)</InputLabel>
                    <Select
                      labelId="selectAllDist-label"
                      id="dash_schools"
                      autoFocus
                      className="dash_schools_drpdown"
                      multiple
                      value={selectedSchools}
                      onChange={(e) => {
                        handleSchoolsChange(e)
                      }}
                      input={<Input />}
                      renderValue={(selected) => {
                        console.log(isAllSelected());
                        if (isAllSelected()) {
                          return 'All';
                        } else {
                          return selected.map((x) => dashboardData.schoolList.find((item) => item.schoolId == x).schoolName).join(', ');
                        }
                      }}
                      MenuProps={MenuProps}
                      sx={{ width: '100%', backgroundColor: 'rgba(0,0,0,.04)', margin: '0px', borderRadius: "5px 5px 0px 0px", }}
                    
                    >
                       {/* "Select All" option */}
                      <MenuItem value="select_all" onClick={(e) => handleSelectAll} sx={{ padding: '0px 16px' }} >
                        <Checkbox
                          checked={isAllSelected() || 
                            selectedSchools.findIndex((item) => item === 'select_all') >= 0
                          }
                          sx={{
                            color: '#003c68',
                            transform: "scale(0.8)",
                            padding: '4px 4px 4px 0px',
                            '&.Mui-checked': {
                              color: '#ff4081',
                            },
                          }}
                        />
                        <ListItemText primary="All Schools" />
                      </MenuItem>


                      {/* Other options */}
                      {dashboardData.schoolList.map((variant) => (
                          <MenuItem key={variant.schoolId} value={variant.schoolId} sx={{ padding: '0px 16px' }} >
                          <Checkbox
                            checked={
                              selectedSchools.findIndex((item) => item == variant.schoolId) >= 0
                            }
                            sx={{
                              color: '#003c68',
                              transform: "scale(0.8)",
                              padding: '4px 4px 4px 0px',
                              '&.Mui-checked': {
                                color: '#ff4081',
                              },
                            }}
                          />
                          <ListItemText primary={variant.schoolName} />
                        </MenuItem>
                      ))}
                    </Select>
                    {isUserError.schoolError && <FormHelperText sx={{ marginLeft: '0px' }}>Select school(s)</FormHelperText>}
                  </FormControl>

                </DialogContentText>
              </DialogContent>
              <DialogActions className="dash_actionFooterButton">
              <Button variant="contained" className="dash_save_button" onClick={handleSave} disabled ={emailError}>Save</Button>
              <Button variant="contained" onClick={addDashboardClose} className="dash_cancel_button" autoFocus> Cancel </Button>
            </DialogActions>
            </Dialog>
            </>
            )}

              {/* //Update Users */}
              <Dialog
                open={openUpdate}
                onClose={updateDashboardClose}
                aria-labelledby="addDashboardLabel"
                aria-describedby="addDashboardDescription"
                sx={{
                  "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                      width: "100%",
                      maxWidth: "400px",  // Set your width here
                    },
                  },
                }}
              >
                <DialogTitle id="addDashboardTitle" className="dash_dailogTitle">
                  UPDATE DASHBOARD USER
                </DialogTitle>
                <DialogContent sx={{ widdth: '100%' }}>
                  <DialogContentText id="addDashboardDescription">
                    <FormControl sx={{ width: '100%' }} error={isUpdateUserError.firstNameUpdateError}>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="fname"
                        label="First name"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={updateRow.firstname}
                        onChange={(e) => {
                          setUpdateRow({ ...updateRow, firstname: e.target.value });

                          if (e.target.value.trim() === '') {
                            setIsUpdateUserError((prevState) => ({
                              ...prevState,
                              firstNameUpdateError: true
                            }));
                          } else {
                            setIsUpdateUserError((prevState) => ({
                              ...prevState,
                              firstNameUpdateError: false
                            }));
                          }

                        }}
                        inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input text
                        InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input label fullWidth
                        sx={{
                          marginTop: '0px', backgroundColor: 'rgba(0,0,0,.04)', borderRadius: "5px 5px 0px 0px",
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#000000",
                          }
                        }}
                      />
                      {isUpdateUserError.firstNameUpdateError && <FormHelperText>Please enter a first name.</FormHelperText>}
                    </FormControl>
                    <FormControl sx={{ width: '100%', paddingTop: '20px' }}>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="lname"
                        label="Last name"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={updateRow.lastname}
                        onChange={(e) => {
                          setUpdateRow({ ...updateRow, lastname: e.target.value })
                        }}
                        inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input text
                        InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input label fullWidth
                        sx={{
                          marginTop: '0px', backgroundColor: 'rgba(0,0,0,.04)', borderRadius: "5px 5px 0px 0px",
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#000000",
                          }
                        }}
                      />
                    </FormControl>
                    <FormControl sx={{ width: '100%', paddingTop: '20px' }}>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="email"
                        label="Email"
                        type="email"
                        fullWidth
                        variant="standard"
                        value={updateRow.email}
                        onChange={(e) => {
                          setUpdateRow({ ...updateRow, email: e.target.value })
                        }}
                        inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input text
                        InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input label fullWidth
                        sx={{
                          marginTop: '0px', backgroundColor: 'rgba(0,0,0,.04)', borderRadius: "5px 5px 0px 0px",
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#000000",
                          }
                        }}
                      />
                    </FormControl>
                    <FormControl sx={{ width: '100%', paddingTop: '20px' }}>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="school"
                        label="School"
                        type="email"
                        fullWidth
                        variant="standard"
                        disabled
                        value={updateRow.schoolName}
                        inputProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input text
                        InputLabelProps={{ style: { fontSize: 13, width: '100%', padding: '5px', color: '#000000' } }} // font size of input label fullWidth
                        sx={{
                          marginTop: '0px', backgroundColor: 'rgba(0,0,0,.04)', borderRadius: "5px 5px 0px 0px",
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#000000",
                          }
                        }}
                      />
                    </FormControl>
                  </DialogContentText>
                </DialogContent>
                <DialogActions className="dash_actionFooterButton">
                  <Button variant="contained" className="dash_save_button"
                    onClick={event => handleUpdate(updateRow)} >Update</Button>
                  <Button variant="contained" onClick={updateDashboardClose} className="dash_cancel_button" autoFocus> Cancel </Button>
                </DialogActions>
              </Dialog>
            </div>
            <div className='dash_filterInput'>
              <Box
                component="form"
                sx={{
                  '& > :not(style)': { width: '100%' },
                }}
                noValidate
                autoComplete="off"
              >
                <TextField id="dash_filterInpText" label="FILTER" value={searchText} onChange={handleInputChange} variant="standard" />
              </Box>
            </div>
            <div className='dash_userTable'>
              <TableContainer component={Paper} sx={{ height: "60vh" }}>
                <Table sx={{ minWidth: 650 }} stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left" className='dash_tableHeader'>NAME</TableCell>
                      <TableCell align="left" className='dash_tableHeader'>EMAIL</TableCell>
                      <TableCell align="left" className='dash_tableHeader'>SCHOOL</TableCell>
                      <TableCell align="left" className='dash_tableHeader'>ACCESS LEVEL</TableCell>
                      <TableCell align="left" className='dash_tableHeader'>SUBMITTED DATE</TableCell>
                      <TableCell align="left" className='dash_tableHeader'>EXP. DATE</TableCell>
                      <TableCell align="left" className='dash_tableHeader'>ACTIONS</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dashboardUsersData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                      <TableRow
                        key={row.name}
                        sx={{ padding: '0px 16px', "&:last-child td, &:last-child th": { border: 0 } }}
                      >
                        <TableCell scope="row" className='mdash_tableBody'>{row.firstname} {row.lastname}</TableCell>
                        <TableCell align="left" className='mdash_tableBody mdash_email_column'>{row.email}</TableCell>
                        <TableCell align="left" className='mdash_tableBody'>{row.school}</TableCell>
                        <TableCell align="left" className='mdash_tableBody'>{row.accesslevel}</TableCell>
                        <TableCell align="left" className='mdash_tableBody mdash_date_column'>{row.submitteddDate}</TableCell>
                        <TableCell align="left" className='mdash_tableBody mdash_date_column'>{row.expDate}</TableCell>
                        <TableCell align="left" className='mdash_tableBody'>
                        <div className="dash_actionButton">
                        <Tooltip title='Edit user details' placement="top-start">
                          {localStorage.getItem("academicyear") === 'currentyear' ? (
                            <a onClick={event => updateDashboardDialog(row)}>
                              <img alt="Edit School" src={require("../../assets/images/editDC_new.png")} className="dash_action_imge" />
                            </a>
                          ) : (
                            <a onClick={event => handleYearSelection()}>
                              <img alt="Edit School" src={require("../../assets/images/editDC_new.png")} className="dash_action_imge" />
                            </a>
                          )}
                        </Tooltip>
                        <Tooltip title='Delete school/user' placement="top-start">
                          {localStorage.getItem("academicyear") === 'currentyear' ? (
                            <a onClick={event => deleteDashboardDialog(row)}>
                              <img alt="Delete School" src={require("../../assets/images/deleteDC_new.png")} className="dash_action_imge" />
                            </a>
                          ) : (
                            <a onClick={event => handleYearSelection()}>
                              <img alt="Delete School" src={require("../../assets/images/deleteDC_new.png")} className="dash_action_imge" />
                            </a>
                          )}
                        </Tooltip>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                    <Dialog
                      open={openDelete}
                      onClose={deleteDashboardClose}
                      aria-labelledby="deleteDashboardLabel"
                      aria-describedby="deleteDashboardDescription"
                    >
                      <DialogTitle id="deleteDashboardTitle">
                        Delete Dashboard User
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText id="deleteDashboardDescription">
                          <div>
                            Delete Dashboard User from 'Malcolm X Elementary' school in 'Alameda' County and 'Berkeley Unified' District
                          </div>
                        </DialogContentText>
                      </DialogContent>
                      {/* <DialogActions className="dash_actionButton">
                          <Button variant="contained" className="dash_save_button" onClick={event => handleDelete(deleteRow)}>Delete</Button>
                          <Button variant="contained" onClick={deleteDashboardClose} className="dash_cancel_button" autoFocus> Cancel </Button>
                        </DialogActions> */}

                      <DialogActions style={{ justifyContent: 'center' }}>
                        <Button variant="contained" style={{ cursor: 'pointer', backgroundColor: '#ff0000', color: 'white', height: '32px', width: '64px', padding: '4px' }} onClick={event => handleDelete(deleteRow)}>Delete</Button>
                        <Button variant="contained" style={{ cursor: 'pointer', backgroundColor: '#1f9d24', color: 'white', height: '32px', width: '64px', padding: '4px' }} onClick={deleteDashboardClose} autoFocus> Cancel </Button>
                      </DialogActions>
                    </Dialog>
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[50, 100, 150, 200, 250, 300]} // Customize the available rows per page options as needed
                  component="div"
                  count={dashboardUsersData.length} // Total number of rows in the table
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>

              <Dialog
                open={openDelete}
                onClose={deleteDashboardClose}
                aria-labelledby="deleteDashboardLabel"
                aria-describedby="deleteDashboardDescription"
              >
                <DialogTitle id="deleteDashboardTitle">
                  Delete Dashboard User
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="deleteDashboardDescription">
                    <div>
                      Delete Dashboard user {dashboardUserName} for school(s) in {dashboardData.distName} ({dashboardData.countyName} County).
                    </div>
                  </DialogContentText>
                </DialogContent>
                {/* <DialogActions className="dash_actionButton">
                                <Button variant="contained" className="dash_save_button" onClick={event => handleDelete(deleteRow)}>Delete</Button>
                                <Button variant="contained" onClick={deleteDashboardClose} className="dash_cancel_button" autoFocus> Cancel </Button>
                              </DialogActions> */}

                <DialogActions style={{ justifyContent: 'center' }}>
                  <Button variant="contained" className="dash_save_button" onClick={event => handleDelete(deleteRow)}>Delete</Button>
                  <Button variant="contained" onClick={deleteDashboardClose} className="dash_cancel_button" autoFocus> Cancel </Button>
                </DialogActions>
              </Dialog>
            </div>
          </div> </> : ' '}
    </div>
  )
}


export default Dashboard